/*
 * A single hover/focus tooltip shared by the components that label icon-only
 * controls. It lives on the body so it escapes any clipping container, and it
 * sits above host overlays.
 */

import { h } from './core.js';

let tip = null;

/**
 * Shows plain text beside an element.
 * @param {HTMLElement} anchor
 * @param {string} text
 * @param {'below'|'right'} [placement='below']
 */
export function showTip(anchor, text, placement = 'below') {
	if (!anchor || !anchor.isConnected || text === undefined || text === null || text === '') return;
	if (!tip) {
		tip = h('div', { className: 'dfc dfc-tip', role: 'tooltip' });
		document.body.appendChild(tip);
	}
	if (!tip.isConnected) document.body.appendChild(tip);
	tip.textContent = String(text);
	tip.style.visibility = 'hidden';
	tip.style.display = 'block';
	const at = anchor.getBoundingClientRect();
	const own = tip.getBoundingClientRect();
	let left, top;
	if (placement === 'right') {
		left = window.innerWidth - at.right >= own.width + 12 ? at.right + 8 : at.left - own.width - 8;
		top = at.top + (at.height - own.height) / 2;
	} else {
		left = at.left + (at.width - own.width) / 2;
		top = at.bottom + 6;
		if (top + own.height > window.innerHeight - 4) top = at.top - own.height - 6;
	}
	left = Math.max(4, Math.min(left, window.innerWidth - own.width - 4));
	top = Math.max(4, Math.min(top, window.innerHeight - own.height - 4));
	tip.style.left = Math.round(left) + 'px';
	tip.style.top = Math.round(top) + 'px';
	tip.style.visibility = 'visible';
}

/** Hides the tooltip and takes it off the page, so nothing is left behind. */
export function hideTip() {
	if (tip && tip.parentNode) tip.parentNode.removeChild(tip);
}
